<template>
  <div class="container">
    <!-- 筛选 -->
    <div>
      <el-form :inline="true" :model="filters">
        <el-form-item :label="$t('Operator')" v-show="zong">
          <el-select
            v-model="filters.SellerId"
            @change="changeSellerId"
            :placeholder="$t('Operator')"
            style="width: 150px"
          >
            <el-option
              v-for="item in seller"
              :key="item.SellerId"
              :label="item.SellerName"
              :value="item.SellerId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('channel')">
          <el-select
            v-model="filters.ChannelId"
            :placeholder="$t('channel')"
            style="width: 150px"
            clearable
          >
            <el-option
              v-for="item in channel"
              :key="item.ChannelId"
              :label="item.Name"
              :value="item.ChannelId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('GameType')">
          <el-select
            v-model="filters.GameType"
             :placeholder="$t('all')"
            style="width: 150px"
            clearable
            @change="GameTypeChange"
          >
            <el-option
              v-for="item in gameTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('Game')+':'">
          <el-select
            filterable
            multiple
            collapse-tags
            v-model="filters.GameId"
            :placeholder="$t('Game')"
            style="width: 200px"
            clearable
          >
            <el-option
              v-for="item in filterGameList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('Room')">
          <el-select
            v-model="filters.RoomLevel"
           :placeholder="$t('Room')"
            style="width: 150px"
            clearable
          >
            <el-option
              v-for="item in hrooms"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('BettingAddress')">
          <el-input
            :placeholder="$t('BettingAddress')"
            v-model="filters.Address"
            clearable
            style="width: 180px"
          >
          </el-input>
        </el-form-item>
        <el-form-item  :label="$t('PrimaryAgentID')">
          <el-select
            filterable
            multiple
            collapse-tags
            v-model="filters.TopAgentId"
             :placeholder="$t('PrimaryAgentID')"
            style="width: 220px"
            clearable
          >
            <el-option
              v-for="item in topAgentList"
              :key="item.id"
              :label="item.name"
              :value="+item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-refresh"
            class="mr10"
            @click="handleQuery"
            >{{$t('Search')}}</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-plus"
            class="mr10"
            v-show="false"
            @click="handleAdd"
            >{{$t('Add')}}</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div style="margin-bottom: 20px">
      <el-button type="primary" class="mr10" @click="followSettings"
        >{{ $t('BatchFollowSettings') }}</el-button
      >
      <el-button type="primary" class="mr10" @click="showOnAndoffGame"
        >{{ $t('EnableDisable') }}</el-button
      >
      <el-button type="primary" class="mr10" @click="applyPlan(1)"
        >{{ $t('ApplyDowngradeScheme') }}</el-button
      >
      <el-button type="primary" class="mr10" @click="OnClickGameLinkSwitch"
        >{{ $t('GameChain') }} {{ $t('EnableDisable') }}</el-button
      >
    </div>
    <!-- 展示内容按钮 -->
    <div style="text-align: right; margin-top: -50px; margin-bottom: 10px">
      <el-dropdown :hide-on-click="false">
        <!-- <el-button type="primary" icon="el-icon-setting" class="square-button"> -->
        <el-button type="primary" icon="el-icon-setting"> </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item divided>
            <div class="dropdown-content">
              <el-button type="text" @click="OnSelectAllShowOptions"
                >{{ $t('SelectAll') }}</el-button
              >
              <el-button type="text" @click="OnUnSelectAllShowOptions"
                >{{ $t('DeselectAll') }}</el-button
              >
              <el-checkbox-group
                v-model="mShowSelects"
                @change="OnHandleSelectShowChange"
              >
                <div style="display: flex; flex-direction: column">
                  <el-checkbox
                    v-for="option in mShowOptions"
                    :key="option.Key"
                    :label="option.Key"
                  >
                    {{ option.Lbl }}
                  </el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!-- 表 -->
    <div>
      <el-table
        :data="table_data"
        border
        class="table"
        :cell-style="{ padding: '0' }"
        @selection-change="handleSelectionChange"
        :key="mShowTableKey"
      >
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column
          align="center"
          prop="SellerName"
          :label="$t('Operator')"
          width="100"
          v-if="zong && IsNeedShow('SellerName')"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          fixed
          align="center"
          :label="$t('Channel')"
          width="90"
          show-overflow-tooltip
          v-if="IsNeedShow('ChannelId')"
        >
          <template slot-scope="scope">
            <span>{{ channelmap[scope.row.ChannelId] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed
          align="center"
          prop="topAgentName"
          :label="$t('agent')"
          width="150"
          show-overflow-tooltip
          v-if="IsNeedShow('topAgentName')"
        ></el-table-column>
        <el-table-column
          fixed
          align="center"
          prop="GameId"
          :label="$t('GameType')"
          width="120"
          show-overflow-tooltip
          v-if="IsNeedShow('GameId')"
        >
          <template slot-scope="scope">
            {{ filterGameType(scope.row.GameId) }}
          </template>
        </el-table-column>
        <el-table-column
          fixed
          align="center"
          prop="GameName"
          :label="$t('GameName')"
          width="100"
          show-overflow-tooltip
          v-if="IsNeedShow('GameName')"
        ></el-table-column>
        <el-table-column
          fixed
          align="center"
          prop="RoomName"
          :label="$t('RoomName')"
          width="80"
          show-overflow-tooltip
          v-if="IsNeedShow('RoomName')"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="Address"
          :label="$t('BettingAddress')"
          width="300"
          show-overflow-tooltip
          v-if="IsNeedShow('Address')"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="Address"
          :label="$t('AddressBalance')"
          width="110"
          show-overflow-tooltip
          v-if="IsNeedShow('AddressAmount')"
        >
          <template slot-scope="scope">
            {{
              `${Math.floor(scope.row.AmountUsdt)},${Math.floor(
                scope.row.AmountTrx
              )}`
            }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          :label="$t('Status')"
          width="60"
          v-if="IsNeedShow('State')"
        >
          <template slot-scope="scope">
            <el-link
              :underline="false"
              type="danger"
              v-if="scope.row.State == 2"
              >{{$t('deactivate')}}</el-link
            >
            <el-link
              :underline="false"
              type="primary"
              v-if="scope.row.State == 1"
              >{{$t('Enable')}}</el-link
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="IsHot"
          :label="$t('Popular')"
          width="60"
          align="center"
          v-if="IsNeedShow('IsHot')"
        >
          <template slot-scope="scope">
            <span :class="{ red: scope.row.IsHot == 1 }">{{
              scope.row.IsHot == 1 ? $t('Yes') : $t('No')
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="IsNew"
          :label="$t('NewGame')"
          width="60"
          align="center"
          v-if="IsNeedShow('IsNew')"
        >
          <template slot-scope="scope">
            <span :class="{ red: scope.row.IsNew == 1 }">{{
              scope.row.IsNew == 1 ? $t('Yes') : $t('No')
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="IsRecom"
          :label="$t('IsRecommended')"
          width="80"
          align="center"
          v-if="IsNeedShow('IsRecom')"
        >
          <template slot-scope="scope">
            <span :class="{ red: scope.row.IsRecom == 1 }">{{
              scope.row.IsRecom == 1 ? $t('Yes') : $t('No')
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
         :label="$t('FlowAlgorithm')"
          width="80"
          show-overflow-tooltip
          v-if="IsNeedShow('LiuSuiType')"
        >
          <template slot-scope="scope">
            {{ getLiuSui(scope.row.LiuSuiType) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="FeeRate"
          :label="$t('HandlingFeeRate')"
          width="80"
          show-overflow-tooltip
          v-if="IsNeedShow('FeeRate')"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="BackFeeRate"
          :label="$t('RefundRate')"
          width="80"
          show-overflow-tooltip
          v-if="IsNeedShow('BackFeeRate')"
        ></el-table-column>
        <el-table-column
          align="center"
          :label="$t('BetRestrictionTRX')"
          width="100"
          show-overflow-tooltip
          v-if="IsNeedShow('LimitMinTRX')"
        >
          <template slot-scope="scope">
            {{ `${scope.row.TrxLimitMin} - ${scope.row.TrxLimitMax}` }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          :label="$t('andBettingRestrictionsTRX')"
          width="120"
          show-overflow-tooltip
          v-if="IsNeedShow('LimitMinHeTRX')"
        >
          <template slot-scope="scope">
            {{
              scope.row.GameId % 10 === 4
                ? `${scope.row.TrxLimitMinHe} -
            ${scope.row.TrxLimitMaxHe}`
                : "--"
            }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          :label="$t('BetRestrictionUSDT')"
          width="120"
          show-overflow-tooltip
          v-if="IsNeedShow('LimitMin')"
        >
          <template slot-scope="scope">
            {{ `${scope.row.UsdtLimitMin} - ${scope.row.UsdtLimitMax}` }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          :label="$t('andBettingRestrictionsUSDT')"
          width="130"
          show-overflow-tooltip
          v-if="IsNeedShow('LimitMinHe')"
        >
          <template slot-scope="scope">
            {{
              scope.row.GameId % 10 === 4
                ? `${scope.row.UsdtLimitMinHe} -
            ${scope.row.UsdtLimitMaxHe}`
                : "--"
            }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="FenChengRate"
          :label="$t('RevenueShareRatio')"
          width="80"
          show-overflow-tooltip
          v-if="IsNeedShow('FenChengRate')"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="IsVipGame"
          :label="$t('VIPFlow')"
          width="80"
          show-overflow-tooltip
          v-if="IsNeedShow('IsVipGame')"
        >
          <template slot-scope="scope">
            <span>{{ vipGame[scope.row.IsVipGame] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="OnlineMin"
          :label="$t('InThePlayerCountRange')"
          width="300"
          show-overflow-tooltip
          v-if="IsNeedShow('OnlineMin')"
        >
          <template slot="header">
            <span>{{ $t('InThePlayerCountRange') }}</span>
            <el-tooltip
              :content="$t('activePlayerLimitRules')"
              placement="top"
            >
              <i
                class="el-icon-question"
                style="margin-left: 5px; cursor: pointer"
              ></i>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.OnlineMin"
              disabled
              style="width: 80px"
            >
            </el-input>
            -
            <el-input
              v-model="scope.row.OnlineMax"
              disabled
              style="width: 80px"
              :style="{ textAlign: 'center' }"
            >
            </el-input>
            <el-button
              type="text"
              icon="el-icon-edit"
              @click="OnHandleEditorOnline(scope.row)"
              >{{$t('Edit')}}人数区间
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
           :label="$t('Actions')"
          width="250"
          show-overflow-tooltip
          v-if="IsNeedShow('Opt')"
        >
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="开启体验后,首次投注前10局,10TRX起投"
              placement="top-end"
            >
              <el-button
                type="text"
                icon="el-icon-edit"
                v-show="auth2('改')"
                class="green"
                @click="setTiYan(scope.row, 1)"
                v-if="scope.row.TiYan == 2"
                >开启新手体验</el-button
              >
              <el-button
                type="text"
                icon="el-icon-edit"
                v-show="auth2('改')"
                class="red"
                @click="setTiYan(scope.row, 2)"
                v-if="scope.row.TiYan == 1"
                >关闭新手体验</el-button
              >
            </el-tooltip>
            <el-button
              style="padding-left: 10px"
              type="text"
              icon="el-icon-edit"
              class="red"
              v-show="auth2('改') && scope.row.State == 1"
              @click="setState(scope.row, 2)"
              >{{$t('deactivate')}}</el-button
            >
            <el-button
              type="text"
              icon="el-icon-edit"
              v-show="auth2('改') && scope.row.State != 1"
              @click="setState(scope.row, 1)"
              >{{$t('Enable')}}</el-button
            >
            <el-button
              type="text"
              icon="el-icon-edit"
              v-show="auth2('改')"
              @click="handleModify(scope.$index)"
              >{{$t('Edit')}}</el-button
            >
            <el-button
              type="text"
              icon="el-icon-edit"
              v-show="auth2('改')"
              @click="handleModifyJp(scope.$index)"
              v-if="jiangPeiGameList.indexOf(Number(scope.row.GameId)) !== -1"
              >{{$t('ReductionCompensation')}}
            </el-button>
            <el-button
              type="text"
              icon="el-icon-edit"
              v-show="auth2('改')"
              @click="handleModifyStopJp(scope.$index)"
              v-if="jiangPeiGameList.indexOf(Number(scope.row.GameId)) !== -1"
              >停止降赔
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        style="margin-top: 5px"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        :total="total"
        @current-change="handleQuery"
        :page-size="pagesize"
        :page-sizes="pagesizes"
        :current-page="current_row"
      ></el-pagination>
    </div>
    <!--对话框-->
    <div>
      <el-dialog
        :title="dialog.title"
        :visible.sync="dialog.show"
        width="750px"
        center
      >
        <el-form :inline="true" label-width="140px">
          <el-form-item :label="$t('Operator')" v-show="zong">
            <el-select
              v-model="dialog.data.SellerId"
              @change="changeSellerId"
              :placeholder="$t('Operator')"
              style="width: 390px"
              :disabled="dialog.type == 'alter'"
            >
              <el-option
                v-for="item in seller"
                :key="item.SellerId"
                :label="item.SellerName"
                :value="item.SellerId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Game')+':'">
            <el-select
              v-model="dialog.data.GameId"
              :placeholder="$t('Game')"
              style="width: 390px"
              :disabled="dialog.type == 'alter'"
            >
              <el-option
                v-for="item in hgames"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Room')">
            <el-select
              v-model="dialog.data.RoomLevel"
              :placeholder="$t('Room')"
              style="width: 390px"
              :disabled="dialog.type == 'alter'"
            >
              <el-option
                v-for="item in hrooms"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="地址:">
            <el-input
              v-model="dialog.data.Address"
              style="width: 400px"
              :disabled="true"
            ></el-input>
            <el-button
              type="primary"
              icon="el-icon-refresh"
              class="mr10"
              style="margin-left: 15px"
              @click="handleFlushAddress"
              v-show="dialog.type == 'add'"
              >刷新</el-button
            >
          </el-form-item>
          <el-form-item :label="$t('FlowAlgorithm')">
            <el-select
              v-model="dialog.data.LiuSuiType"
              :placeholder="$t('FlowAlgorithm')"
              style="width: 390px"
            >
              <el-option
                v-for="item in liusuis"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('HandlingFeeRate')"
            v-show="
              dialog.data.GameId != 5 &&
              dialog.data.GameId != 105 &&
              dialog.data.GameId != 135 &&
              dialog.data.GameId != 205 &&
              dialog.data.GameId != 305
            "
          >
            <el-input
              v-model="dialog.data.FeeRate"
              :disabled="dialog.data.GameId == 6 || dialog.data.GameId == 7"
              style="width: 390px"
            ></el-input>
          </el-form-item>
          <el-form-item label="vip流水累加:" style="width: 390px">
            <el-radio-group v-model="dialog.data.IsVipGame">
              <el-radio :label="1">{{ vipGame["1"] }}</el-radio>
              <el-radio :label="2">{{ vipGame["2"] }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('Tag')+':'" style="width: 500px">
            <el-radio-group v-model="tag">
              <el-radio :label="1">无</el-radio>
              <el-radio :label="2">{{$t('Popular') }}</el-radio>
              <el-radio :label="3">{{ $t('NewGame') }}</el-radio>
              <el-radio :label="4">{{ $t('IsRecommended') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="和倍数:"
            v-show="
              dialog.data.GameId == 4 ||
              dialog.data.GameId == 104 ||
              dialog.data.GameId == 134 ||
              dialog.data.GameId == 204 ||
              dialog.data.GameId == 304
            "
          >
            <el-input
              type="number"
              v-model="dialog.data.hebeishu"
              style="width: 390px"
            ></el-input>
          </el-form-item>
          <el-tooltip
            class="item"
            effect="dark"
            content="押注庄或闲,开和时扣除比例(例如:1%请填写0.01)"
            placement="top-end"
            v-show="
              dialog.data.GameId == 4 ||
              dialog.data.GameId == 104 ||
              dialog.data.GameId == 134 ||
              dialog.data.GameId == 204 ||
              dialog.data.GameId == 304
            "
          >
            <el-form-item :label="$t('OpenAndReturnRate')">
              <el-input
                type="number"
                v-model="dialog.data.hefeerate"
                style="width: 390px"
              ></el-input>
            </el-form-item>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="如点数一致，除1∽2点外，其他返还时扣此条设置的手续费(例如:1%请填写0.01)"
            placement="top-end"
            v-show="
              dialog.data.GameId == 5 ||
              dialog.data.GameId == 105 ||
              dialog.data.GameId == 135 ||
              dialog.data.GameId == 205 ||
              dialog.data.GameId == 305
            "
          >
            <el-form-item label="打平返还:">
              <el-input
                v-model="dialog.data.hefeerate"
                style="width: 390px"
              ></el-input>
            </el-form-item>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="无效下注=下注金额最后一位不是1,2,3(例如:1%请填写0.01)"
            placement="top-end"
            v-show="
              dialog.data.GameId == 4 ||
              dialog.data.GameId == 104 ||
              dialog.data.GameId == 134
            "
          >
            <el-form-item label="无效下注返还费率:">
              <el-input
                v-model="dialog.data.wuxiaofeerate"
                style="width: 390px"
              ></el-input>
            </el-form-item>
          </el-tooltip>
          <el-form-item
            :label="dialog.data.GameId % 10 === 4 ? '庄闲最小TRX:' : '最小TRX:'"
            v-show="
              dialog.data.GameId != 6 &&
              dialog.data.GameId != 7 &&
              (dialog.data.GameId < 100 || dialog.data.GameId > 300)
            "
          >
            <el-input
              v-model="dialog.data.TrxLimitMin"
              style="width: 140px"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="dialog.data.GameId % 10 === 4 ? '庄闲最大TRX:' : '最大TRX:'"
            v-show="
              dialog.data.GameId != 6 &&
              dialog.data.GameId != 7 &&
              (dialog.data.GameId < 100 || dialog.data.GameId > 300)
            "
          >
            <el-input
              v-model="dialog.data.TrxLimitMax"
              style="width: 140px"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="
              dialog.data.GameId % 10 === 4 ? '庄闲最小USDT:' : '最小USDT:'
            "
          >
            <el-input
              v-model="dialog.data.UsdtLimitMin"
              style="width: 140px"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="
              dialog.data.GameId % 10 === 4 ? '庄闲最大USDT:' : '最大USDT:'
            "
          >
            <el-input
              v-model="dialog.data.UsdtLimitMax"
              style="width: 140px"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="和最小TRX:"
            v-show="
              dialog.data.GameId % 10 === 4 &&
              (dialog.data.GameId < 100 || dialog.data.GameId > 300)
            "
          >
            <el-input
              v-model="dialog.data.TrxLimitMinHe"
              style="width: 140px"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="和最大TRX:"
            v-show="
              dialog.data.GameId % 10 === 4 &&
              (dialog.data.GameId < 100 || dialog.data.GameId > 300)
            "
          >
            <el-input
              v-model="dialog.data.TrxLimitMaxHe"
              style="width: 140px"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="和最小USDT:"
            v-show="dialog.data.GameId % 10 === 4"
          >
            <el-input
              v-model="dialog.data.UsdtLimitMinHe"
              style="width: 140px"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="和最大USDT:"
            v-show="dialog.data.GameId % 10 === 4"
          >
            <el-input
              v-model="dialog.data.UsdtLimitMaxHe"
              style="width: 140px"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('RefundRate')">
            <el-input
              v-model="dialog.data.BackFeeRate"
              style="width: 140px"
            ></el-input>
          </el-form-item>
          <el-form-item label="游戏分成比例:">
            <el-input
              v-model="dialog.data.FenChengRate"
              style="width: 140px"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="单玩法最高派奖:"
            v-show="dialog.data.GameId >= 6 && dialog.data.GameId <= 7"
          >
            <el-input
              v-model="dialog.data.SUsdtLimitMax"
              style="width: 140px"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="单期最高派奖:"
            v-show="dialog.data.GameId >= 6 && dialog.data.GameId <= 7"
          >
            <el-input
              v-model="dialog.data.PUsdtLimitMax"
              style="width: 140px"
            ></el-input>
          </el-form-item>
          <div
            v-show="
              dialog.data.GameId == 5 ||
              dialog.data.GameId == 105 ||
              dialog.data.GameId == 135 ||
              dialog.data.GameId == 205 ||
              dialog.data.GameId == 305
            "
          >
            <div style="margin-bottom: 10px">手续费设置:</div>
            <el-tooltip
              class="item"
              effect="dark"
              content="此条配置决定App端显示的赔率"
              placement="top-end"
            >
              <el-form-item label="牛一手续费:">
                <el-input
                  v-model="dialog.data.feerateniu1"
                  style="width: 140px"
                ></el-input>
              </el-form-item>
            </el-tooltip>
            <el-form-item label="牛二手续费:">
              <el-input
                v-model="dialog.data.feerateniu2"
                style="width: 140px"
              ></el-input>
            </el-form-item>
            <el-form-item label="牛三手续费:">
              <el-input
                v-model="dialog.data.feerateniu3"
                style="width: 140px"
              ></el-input>
            </el-form-item>
            <el-form-item label="牛四手续费:">
              <el-input
                v-model="dialog.data.feerateniu4"
                style="width: 140px"
              ></el-input>
            </el-form-item>
            <el-form-item label="牛五手续费:">
              <el-input
                v-model="dialog.data.feerateniu5"
                style="width: 140px"
              ></el-input>
            </el-form-item>
            <el-form-item label="牛六手续费:">
              <el-input
                v-model="dialog.data.feerateniu6"
                style="width: 140px"
              ></el-input>
            </el-form-item>
            <el-form-item label="牛七手续费:">
              <el-input
                v-model="dialog.data.feerateniu7"
                style="width: 140px"
              ></el-input>
            </el-form-item>
            <el-form-item label="牛八手续费:">
              <el-input
                v-model="dialog.data.feerateniu8"
                style="width: 140px"
              ></el-input>
            </el-form-item>
            <el-form-item label="牛九手续费:">
              <el-input
                v-model="dialog.data.feerateniu9"
                style="width: 140px"
              ></el-input>
            </el-form-item>
            <el-form-item label="牛牛手续费:">
              <el-input
                v-model="dialog.data.feerateniu10"
                style="width: 140px"
              ></el-input>
            </el-form-item>
            <div style="margin-bottom: 10px">倍数设置:</div>
            <el-form-item label="牛一倍数:">
              <el-input
                v-model="dialog.data.beishuniu1"
                style="width: 140px"
              ></el-input>
            </el-form-item>
            <el-form-item label="牛二倍数:">
              <el-input
                v-model="dialog.data.beishuniu2"
                style="width: 140px"
              ></el-input>
            </el-form-item>
            <el-form-item label="牛三倍数:">
              <el-input
                v-model="dialog.data.beishuniu3"
                style="width: 140px"
              ></el-input>
            </el-form-item>
            <el-form-item label="牛四倍数:">
              <el-input
                v-model="dialog.data.beishuniu4"
                style="width: 140px"
              ></el-input>
            </el-form-item>
            <el-form-item label="牛五倍数:">
              <el-input
                v-model="dialog.data.beishuniu5"
                style="width: 140px"
              ></el-input>
            </el-form-item>
            <el-form-item label="牛六倍数:">
              <el-input
                v-model="dialog.data.beishuniu6"
                style="width: 140px"
              ></el-input>
            </el-form-item>
            <el-form-item label="牛七倍数:">
              <el-input
                v-model="dialog.data.beishuniu7"
                style="width: 140px"
              ></el-input>
            </el-form-item>
            <el-form-item label="牛八倍数:">
              <el-input
                v-model="dialog.data.beishuniu8"
                style="width: 140px"
              ></el-input>
            </el-form-item>
            <el-form-item label="牛九倍数:">
              <el-input
                v-model="dialog.data.beishuniu9"
                style="width: 140px"
              ></el-input>
            </el-form-item>
            <el-form-item label="牛牛倍数:">
              <el-input
                v-model="dialog.data.beishuniu10"
                style="width: 140px"
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="handleConfirm">{{ $t('Confirm') }}</el-button>
        </span>
      </el-dialog>
    </div>
    <JiangPei ref="jp" />
    <StopJiangPei ref="stopjp" />
    <followSetting
      v-if="followSettingData.show"
      :followSettingData="followSettingData"
      @submitFollowSettingData="submitFollowSettingData"
    ></followSetting>
    <applyPlan
      v-if="applyPlanData.show"
      :applyPlanData="applyPlanData"
      @submitApplyPlanData="submitApplyPlanData"
    >
    </applyPlan>
    <onAndoffGame
      v-if="onAndoffGameData.show"
      :onAndoffGameData="onAndoffGameData"
      @submitonAndoffGameData="submitonAndoffGameData"
    ></onAndoffGame>
    <GameOnlineEditor
      v-if="mOnlineDialogData.show"
      :dialogData="mOnlineDialogData"
      @success="handleQuery"
    ></GameOnlineEditor>
    <GameLinkSwitchDialog
      v-if="mGLinkSwitchDialogData.show"
      :dialogData="mGLinkSwitchDialogData"
    ></GameLinkSwitchDialog>
  </div>
</template>

<script>
import { app } from "@/api/app.js";
import "@/assets/css/k.css";
import base from "@/api/base.js";
import JiangPei from "../components/jiangpei.vue";
import StopJiangPei from "../components/stopjiangpei.vue";
import followSetting from "./components/followSetting.vue";
import applyPlan from "../components/applyPlan.vue";
import onAndoffGame from "./components/onAndoffGame.vue";
import GameOnlineEditor from "./components/GameOnlineEditor.vue";
import GameLinkSwitchDialog from "./components/GameLinkSwitchDialog.vue";
export default {
  extends: base,
  name: "gameList",
  components: {
    JiangPei,
    StopJiangPei,
    followSetting,
    applyPlan,
    onAndoffGame,
    GameOnlineEditor,
    GameLinkSwitchDialog,
  },
  data() {
    return {
      filters: {
        GameId: null,
        GameType: null,
        RoomLevel: "",
        TopAgentId: "",
        Address: "",
      },
      liusuis: [
        {
          id: 1,
          name: "单边",
        },
        {
          id: 2,
          name: "双边",
        },
        {
          id: 3,
          name: "输赢绝对值",
        },
      ],
      jptitle: "test",
      jpshow: false,
      dialogjp: {
        title: "",
        show: false,
        GameId: null,
        Disabled: false,
        data: [],
        current_row: null,
      },
      dialogjpitem: {
        title: "",
        show: false,
      },
      jiangPeiGameList: [
        1, 2, 6, 7, 11, 12, 101, 102, 131, 132, 201, 202, 301, 302, 331, 332,
      ],
      vipGame: {
        1: "参加",
        2: "不参加",
      },
      gameTypeList: [
        { id: -1, name: this.$t('HashGame') },
        { id: -2, name: this.$t('balanceHash') },
      ],
      multipleSelection: [],
      followSettingData: {
        show: false,
        title: "批量跟随设置",
        loading: false,
        TopAgentList: [],
        data: [],
      },
      applyPlanData: {
        show: false,
        type: "",
        title:this.$t('ApplyDowngradeScheme'),
        data: {},
      },
      topAgentList: [],
      onAndoffGameData: {
        show: false,
        title: "启用/禁用",
        data: {},
      },
      tag: 1,
      mShowOptions: [
        { Lbl: this.$t('Channel'), Key: "ChannelId" },
        { Lbl:  this.$t('agent'), Key: "topAgentName" },
        { Lbl: this.$t('GameType'), Key: "GameId" },
        { Lbl: this.$t('GameName'), Key: "GameName" },
        { Lbl: this.$t('RoomName'), Key: "RoomName" },
        { Lbl: this.$t('Operator'), Key: "SellerName" },
        { Lbl: this.$t('BettingAddress'), Key: "Address" },
        { Lbl: this.$t('AddressBalance'), Key: "AddressAmount" },
        { Lbl: this.$t('Status'), Key: "State" },
        { Lbl: this.$t('Popular'), Key: "IsHot" },
        { Lbl: this.$t('NewGame'), Key: "IsNew" },
        { Lbl: this.$t('IsRecommended'), Key: "IsRecom" },
        { Lbl: this.$t('FlowAlgorithm'), Key: "LiuSuiType" },
        { Lbl: this.$t('HandlingFeeRate'), Key: "FeeRate" },
        { Lbl: this.$t('RefundRate'), Key: "BackFeeRate" },
        { Lbl:  this.$t('BetRestrictionTRX'), Key: "LimitMinTRX" },
        { Lbl: this.$t('andBettingRestrictionsTRX'), Key: "LimitMinHeTRX" },
        { Lbl: this.$t('BetRestrictionUSDT'), Key: "LimitMin" },
        { Lbl: this.$t('andBettingRestrictionsUSDT'), Key: "LimitMinHe" },
        { Lbl: this.$t('RevenueShareRatio'), Key: "FenChengRate" },
        { Lbl: "vip流水", Key: "IsVipGame" },
        { Lbl: this.$t('InThePlayerCountRange'), Key: "OnlineMin" },
        { Lbl:this.$t('Actions'), Key: "Opt" },
      ],
      mShowSelects: [],
      mShowTableKey: 0,
      mOnlineDialogData: {
        show: false,
        type: 2,
        row: null,
      },
      mGLinkSwitchDialogData: {
        title: "游戏链",
        show: false,
        row: null,
      },
    };
  },
  computed: {
    filterGameList() {
      if (this.filters.GameType == -1) {
        return this.hgames.filter((item) => item.id < 100 || item.id > 300);
      } else if (this.filters.GameType == -2) {
        return this.hgames.filter((item) => item.id > 100 && item.id <= 205);
      } else {
        return this.hgames;
      }
    },
  },
  created() {
    this.app = app;
    this.getChannel(this.filters.SellerId);
    this.getAllTopAgent(this.filters.ChannelId);
    this.handleQuery();
    this.OnSelectAllShowOptions();
  },
  methods: {
    OnSelectAllShowOptions() {
      this.mShowSelects = this.mShowOptions.map((option) => option.Key);
      this.OnHandleSelectShowChange();
    },
    OnUnSelectAllShowOptions() {
      this.mShowSelects = [];
      this.OnHandleSelectShowChange();
    },
    OnHandleSelectShowChange(pValue) {
      if (this.mShowTableKey > 10000) {
        this.mShowTableKey = 1;
      } else {
        ++this.mShowTableKey;
      }
    },
    OnHandleEditorOnline(pRow) {
      this.mOnlineDialogData.show = true;
      this.mOnlineDialogData.type = 2; // 官方游戏
      this.mOnlineDialogData.row = pRow;
    },
    IsNeedShow(pKey) {
      return this.mShowSelects.includes(pKey);
    },
    submitonAndoffGameData(val) {
      app.getGoogleCode((GoogleCode) => {
        let Ids = this.multipleSelection.map((item) => item.Id);
        const data = {
          SellerId: parseInt(this.filters.SellerId || 0),
          State: val.State,
          Ids,
          GoogleCode,
        };
        app.post("/game/batch", data, (res) => {
          if (res.code == 200) {
            this.$message.success(this.$t('OperationSuccess'));
            this.onAndoffGameData.show = false;
            this.handleQuery();
          }
        });
      });
    },
    showOnAndoffGame() {
      if (!this.multipleSelection.length)
        return this.$message.warning(this.$t('PleaseSelectData'));
      this.onAndoffGameData.show = true;
    },
    OnClickGameLinkSwitch() {
      this.mGLinkSwitchDialogData.show = true;
    },
    getAllTopAgent(ChannelId) {
      const data = {
        SellerId: parseInt(this.filters.SellerId || 0),
        ChannelId,
      };
      app.post("/game/agents", data, (res) => {
        let objData = res.data;
        let result = [];
        for (const key in objData) {
          if (key == 0) {
            result.push({
              name: `官网(${key})`,
              id: key,
            });
          } else {
            result.push({
              name: `${objData[key] || ""}(${key})`,
              id: key,
            });
          }
        }
        this.topAgentList = result;
      });
    },
    setSelecTable(row) {
      return row.State == 1;
    },
    submitFollowSettingData(val) {
      let arr = this.multipleSelection.map((item) => {
        return {
          SellerId: Number(this.filters.SellerId),
          ChannelId: Number(item.ChannelId),
          GameId: Number(item.GameId),
          RoomLevel: Number(item.RoomLevel),
          TopAgentId: Number(item.TopAgentId),
          GameName: item.GameName,
          Id: item.Id,
          Address: item.Address,
          GameName: item.GameName,
        };
      });
      app.getGoogleCode((GoogleCode) => {
        const data = {
          SellerId: Number(this.filters.SellerId),
          Src: {
            SellerId: Number(this.filters.SellerId),
            ChannelId: Number(val.ChannelId),
            GameId: Number(val.GameId),
            RoomLevel: Number(val.RoomLevel),
            TopAgentId: Number(val.TopAgentId),
            Id: val.Id,
            Address: val.Address,
            GameName: val.GameName,
          },
          Dests: arr,
          GoogleCode,
        };
        app.post("/game/sync_setting", data, (res) => {
          if (res.code == 200) {
            this.showEdit = false;
            this.handleQuery(this.page);
            if (res.data.length > 0) {
              let str = res.data.map((obj) => obj.Address).join("\r\n");
              this.$alert(
                `<p>投注地址为:</p><p>${str}</p><p>的游戏无法跟随当前游戏所设置的内容，请检查！</p>`,
                "跟随未成功提示",
                {
                  dangerouslyUseHTMLString: true,
                }
              );
            } else {
              this.$message.success("设置成功");
            }
          }
        });
      });
      this.followSettingData.show = false;
    },
    submitApplyPlanData(val) {
      let ids = this.multipleSelection.map((item) => item.Id);
      app.getGoogleCode((GoogleCode) => {
        const data = {
          SellerId: this.filters.SellerId,
          TempleteId: val,
          Games: ids,
          GoogleCode,
        };
        app.post("/game/game_use_jiangpei_templete", data, (res) => {
          if (res.code == 200) {
            this.applyPlanData.show = false;
            this.handleQuery();
            this.$message.success(this.$t('OperationSuccess'));
          }
        });
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    applyPlan(type) {
      if (!this.multipleSelection.length)
        return this.$message.warning(this.$t('PleaseSelectData'));

      this.applyPlanData.show = true;
      this.applyPlanData.type = type;
    },
    followSettings() {
      if (!this.multipleSelection.length)
        return this.$message.warning(this.$t('PleaseSelectData'));
      this.followSettingData.data = this.multipleSelection;
      this.followSettingData.show = true;
      this.followSettingData.loading = true;
      // this.getTopAgentData();
    },
    filterGameType(id) {
      let gameTypeStr = "";
      if (id < 100 || id > 300) {
        gameTypeStr = this.gameTypeList[0].name;
      } else {
        gameTypeStr = this.gameTypeList[1].name;
      }
      return gameTypeStr;
    },
    setTiYan(item, tiyan) {
      app.getGoogleCode((GoogleCode) => {
        let data = app.clone(item);
        data.TiYan = tiyan;
        app.post(
          "/game/tiyan",
          {
            SellerId: this.filters.SellerId,
            Id: item.Id,
            TiYan: tiyan,
            GoogleCode: GoogleCode,
          },
          () => {
            this.$message.success(this.$t('ModificationSuccessful'));
            this.handleQuery(this.page);
          }
        );
      });
    },
    setState(item, state) {
      app.getGoogleCode((GoogleCode) => {
        let data = app.clone(item);
        data.State = state;
        app.post(
          "/game/state",
          {
            SellerId: this.filters.SellerId,
            Id: item.Id,
            State: state,
            GoogleCode: GoogleCode,
          },
          () => {
            this.$message.success(this.$t('ModificationSuccessful'));
            this.handleQuery(this.page);
          }
        );
      });
    },
    getLiuSui(val) {
      for (let i = 0; i < this.liusuis.length; i++) {
        if (val == this.liusuis[i].id) return this.liusuis[i].name;
      }
      return val;
    },
    flushdata() {
      this.handleQuery(this.page);
    },
    auth2(o) {
      return app.auth2("游戏管理", "游戏列表", o);
    },
    handleQuery(page) {
      this.page = page || 1;
      if (typeof this.page != "number") this.page = 1;
      var data = {
        page: this.page,
        pagesize: this.pagesize,
        SellerId: parseInt(this.filters.SellerId || 0),
        GameId: this.filters.GameId || [],
        ChannelId: Number(this.filters.ChannelId),
        RoomLevel: Number(this.filters.RoomLevel),
        TopAgentId: this.filters.TopAgentId || [],
        Address: this.filters.Address,
        GameType: Number(this.filters.GameType),
      };
      // if (!this.filters.GameId) {
      //   data.GameId = this.filters.GameType;
      // }
      // data.GameId = Number(data.GameId);
      app.post("/game/list", data, (result) => {
        for (let i = 0; i < result.data.data.length; i++) {
          for (let j = 0; j < this.hgames.length; j++) {
            if (result.data.data[i].GameId == this.hgames[j].id) {
              result.data.data[i].GameName = this.hgames[j].name;
            }
          }
          for (let j = 0; j < this.hrooms.length; j++) {
            if (result.data.data[i].RoomLevel == this.hrooms[j].id) {
              result.data.data[i].RoomName = this.hrooms[j].name;
            }
          }
          for (let j = 0; j < this.seller.length; j++) {
            if (this.seller[j].SellerId == result.data.data[i].SellerId)
              result.data.data[i].SellerName = this.seller[j].SellerName;
          }
        }
        this.table_data = result.data.data;
        this.table_data.forEach((item) => {
          item.topAgentName = `${item.AgentName || ""}(${item.TopAgentId})`;
        });
        // console.log(JSON.stringify(this.table_data));
        this.total = result.data.total;
        this.OnHandleSelectShowChange();
      });
    },
    handleFlushAddress() {
      if (this.dialog.data.SellerId <= 0) {
        this.$message.error("请先选择运营商");
        return;
      }
      let data = {
        SellerId: this.dialog.data.SellerId,
        GameId: Number(this.dialog.data.GameId),
        RoomLevel: Number(this.dialog.data.RoomLevel),
      };
      app.post("/address/alloc", data, (result) => {
        this.dialog.data.Address = result.data.Address;
        this.dialog.data = JSON.parse(JSON.stringify(this.dialog.data));
      });
    },
    handleAddJp() {
      let id = 0;
      if (this.dialogjp.data.length > 0) {
        id = this.dialogjp.data[this.dialogjp.data.length - 1].Id;
      }
      this.dialogjp.data.push({
        Id: id + 1,
        BetCount: 0,
        WinCount: 0,
        RateDown: 0,
      });
    },
    handleAdd() {
      this.dialog.type = "add";
      this.dialog.title = "新增游戏";
      this.dialog.data = {
        SellerId: null,
        GameId: null,
        RoomLevel: null,
        TrxLimitMin: null,
        TrxLimitMax: null,
        UsdtLimitMin: null,
        UsdtLimitMax: null,
        TrxLimitMinHe: null,
        TrxLimitMaxHe: null,
        UsdtLimitMinHe: null,
        UsdtLimitMaxHe: null,
        BackFeeRate: null,
        AgentRate: null,
        RewardRate: null,
        LiuSuiType: null,

        hebeishu: null,
        wuxiaofeerate: null,
        hefeerate: null,

        feerateniu1: null,
        feerateniu2: null,
        feerateniu3: null,
        feerateniu4: null,
        feerateniu5: null,
        feerateniu6: null,
        feerateniu7: null,
        feerateniu8: null,
        feerateniu9: null,
        feerateniu10: null,

        beishuniu1: null,
        beishuniu2: null,
        beishuniu3: null,
        beishuniu4: null,
        beishuniu5: null,
        beishuniu6: null,
        beishuniu7: null,
        beishuniu8: null,
        beishuniu9: null,
        beishuniu10: null,
      };
      this.dialog.show = true;
    },
    handleModifyStopJp(index) {
      let data = this.table_data[index];
      this.$refs.stopjp.showDialog(data.SellerId, data.GameId, data.ChannelId);
    },
    handleModifyJp(index) {
      let data = this.table_data[index];
      this.$refs.jp.showDialog(
        data.SellerId,
        data.GameId,
        0,
        0,
        0,
        data.ChannelId,
        data.RoomLevel,
        data.TopAgentId
      );
    },
    handleModifyJPItem(index) {
      this.dialogjp.current_row = index;
      this.dialogjpitem.data = app.clone(this.dialogjp.data[index]);
      this.dialogjpitem.title =
        this.dialogjp.title + " - " + this.dialogjpitem.data.Id;
      this.dialogjpitem.show = true;
    },
    handleModify(index) {
      this.current_row = index;
      this.dialog.type = "alter";
      this.dialog.title = "修改游戏";
      let data = app.clone(this.table_data[index]);
      if (
        data.GameId == 4 ||
        data.GameId == 104 ||
        data.GameId == 134 ||
        data.GameId == 204
      ) {
        let RewardRateEx;
        try {
          RewardRateEx = JSON.parse(data.RewardRateEx);
        } catch (error) {
          RewardRateEx = {};
        }
        data.hebeishu = Number(RewardRateEx.hebeishu || 8);
        data.wuxiaofeerate = Number(RewardRateEx.wuxiaofeerate || 0.001);
        data.hefeerate = Number(RewardRateEx.hefeerate || 0.001);
      } else if (
        data.GameId == 5 ||
        data.GameId == 105 ||
        data.GameId == 135 ||
        data.GameId == 205
      ) {
        let RewardRateEx;
        try {
          RewardRateEx = JSON.parse(data.RewardRateEx);
        } catch (error) {
          RewardRateEx = {};
        }
        RewardRateEx.beishu = RewardRateEx.beishu || [];
        data.beishuniu1 = RewardRateEx.beishu[0] || 1;
        data.beishuniu2 = RewardRateEx.beishu[1] || 2;
        data.beishuniu3 = RewardRateEx.beishu[2] || 3;
        data.beishuniu4 = RewardRateEx.beishu[3] || 4;
        data.beishuniu5 = RewardRateEx.beishu[4] || 5;
        data.beishuniu6 = RewardRateEx.beishu[5] || 6;
        data.beishuniu7 = RewardRateEx.beishu[6] || 7;
        data.beishuniu8 = RewardRateEx.beishu[7] || 8;
        data.beishuniu9 = RewardRateEx.beishu[8] || 9;
        data.beishuniu10 = RewardRateEx.beishu[9] || 10;
        RewardRateEx.feerate = RewardRateEx.feerate || [];
        data.feerateniu1 = RewardRateEx.feerate[0] || 0.05;
        data.feerateniu2 = RewardRateEx.feerate[1] || 0.05;
        data.feerateniu3 = RewardRateEx.feerate[2] || 0.05;
        data.feerateniu4 = RewardRateEx.feerate[3] || 0.05;
        data.feerateniu5 = RewardRateEx.feerate[4] || 0.05;
        data.feerateniu6 = RewardRateEx.feerate[5] || 0.05;
        data.feerateniu7 = RewardRateEx.feerate[6] || 0.05;
        data.feerateniu8 = RewardRateEx.feerate[7] || 0.05;
        data.feerateniu9 = RewardRateEx.feerate[8] || 0.05;
        data.feerateniu10 = RewardRateEx.feerate[9] || 0.05;
        data.hefeerate = RewardRateEx.hefeerate || 0.001;
      }
      this.dialog.data = data;
      if (this.dialog.data.IsHot == 1) {
        this.tag = 2;
      } else if (this.dialog.data.IsNew == 1) {
        this.tag = 3;
      } else if (this.dialog.data.IsRecom == 1) {
        this.tag = 4;
      } else {
        this.tag = 1;
      }
      this.dialog.show = true;
    },
    handleDelJp(index) {
      this.dialogjp.data.splice(index, 1);
    },
    handleConfirmJpItem() {
      this.dialogjpitem.show = false;
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.handleQuery();
    },
    handleConfirm() {
      if (
        this.dialog.data.GameId == 4 ||
        this.dialog.data.GameId == 104 ||
        this.dialog.data.GameId == 134 ||
        this.dialog.data.GameId == 204
      ) {
        this.dialog.data.RewardRateEx = {};
        this.dialog.data.RewardRateEx.hebeishu = Number(
          this.dialog.data.hebeishu
        );
        this.dialog.data.RewardRateEx.wuxiaofeerate = Number(
          this.dialog.data.wuxiaofeerate
        );
        this.dialog.data.RewardRateEx.hefeerate = Number(
          this.dialog.data.hefeerate
        );
        this.dialog.data.RewardRateEx = JSON.stringify(
          this.dialog.data.RewardRateEx
        );
      } else if (
        this.dialog.data.GameId == 5 ||
        this.dialog.data.GameId == 105 ||
        this.dialog.data.GameId == 135 ||
        this.dialog.data.GameId == 205
      ) {
        this.dialog.data.RewardRateEx = {
          beishu: [],
          feerate: [],
          hefeerate: 0,
        };
        if (
          Number(this.dialog.data.feerateniu1) < 0 ||
          Number(this.dialog.data.feerateniu2) < 0 ||
          Number(this.dialog.data.feerateniu3) < 0 ||
          Number(this.dialog.data.feerateniu4) < 0 ||
          Number(this.dialog.data.feerateniu5) < 0 ||
          Number(this.dialog.data.feerateniu6) < 0 ||
          Number(this.dialog.data.feerateniu7) < 0 ||
          Number(this.dialog.data.feerateniu8) < 0 ||
          Number(this.dialog.data.feerateniu9) < 0 ||
          Number(this.dialog.data.feerateniu10) < 0
        ) {
          this.$message.error("手续费不可为负数");
          return;
        }
        if (
          Number(this.dialog.data.beishuniu1) < 0 ||
          Number(this.dialog.data.beishuniu2) < 0 ||
          Number(this.dialog.data.beishuniu3) < 0 ||
          Number(this.dialog.data.beishuniu4) < 0 ||
          Number(this.dialog.data.beishuniu5) < 0 ||
          Number(this.dialog.data.beishuniu6) < 0 ||
          Number(this.dialog.data.beishuniu7) < 0 ||
          Number(this.dialog.data.beishuniu8) < 0 ||
          Number(this.dialog.data.beishuniu9) < 0 ||
          Number(this.dialog.data.beishuniu10) < 0
        ) {
          this.$message.error("倍数不可为负数");
          return;
        }
        if (
          Number(this.dialog.data.beishuniu1) >=
          Number(this.dialog.data.beishuniu2)
        ) {
          this.$message.error("牛一倍数不可大于等于牛二倍数");
          return;
        }
        if (
          Number(this.dialog.data.beishuniu2) >=
          Number(this.dialog.data.beishuniu3)
        ) {
          this.$message.error("牛二倍数不可大于等于牛三倍数");
          return;
        }
        if (
          Number(this.dialog.data.beishuniu3) >=
          Number(this.dialog.data.beishuniu4)
        ) {
          this.$message.error("牛三倍数不可大于等于牛四倍数");
          return;
        }
        if (
          Number(this.dialog.data.beishuniu4) >=
          Number(this.dialog.data.beishuniu5)
        ) {
          this.$message.error("牛四倍数不可大于等于牛五倍数");
          return;
        }
        if (
          Number(this.dialog.data.beishuniu5) >=
          Number(this.dialog.data.beishuniu6)
        ) {
          this.$message.error("牛五倍数不可大于等于牛六倍数");
          return;
        }
        if (
          Number(this.dialog.data.beishuniu6) >=
          Number(this.dialog.data.beishuniu7)
        ) {
          this.$message.error("牛六倍数不可大于等于牛七倍数");
          return;
        }
        if (
          Number(this.dialog.data.beishuniu7) >=
          Number(this.dialog.data.beishuniu8)
        ) {
          this.$message.error("牛七倍数不可大于等于牛八倍数");
          return;
        }
        if (
          Number(this.dialog.data.beishuniu8) >=
          Number(this.dialog.data.beishuniu9)
        ) {
          this.$message.error("牛八倍数不可大于等于牛九倍数");
          return;
        }
        if (
          Number(this.dialog.data.beishuniu8) >=
          Number(this.dialog.data.beishuniu10)
        ) {
          this.$message.error("牛九倍数不可大于等于牛牛倍数");
          return;
        }
        if (Number(this.dialog.data.beishuniu1) > 1) {
          this.$message.error("牛一倍数不可大于1");
          return;
        }
        if (Number(this.dialog.data.beishuniu2) > 2) {
          this.$message.error("牛二倍数不可大于2");
          return;
        }
        if (Number(this.dialog.data.beishuniu3) > 3) {
          this.$message.error("牛三倍数不可大于3");
          return;
        }
        if (Number(this.dialog.data.beishuniu4) > 4) {
          this.$message.error("牛四倍数不可大于4");
          return;
        }
        if (Number(this.dialog.data.beishuniu5) > 5) {
          this.$message.error("牛五倍数不可大于5");
          return;
        }
        if (Number(this.dialog.data.beishuniu6) > 6) {
          this.$message.error("牛六倍数不可大于6");
          return;
        }
        if (Number(this.dialog.data.beishuniu7) > 7) {
          this.$message.error("牛七倍数不可大于7");
          return;
        }
        if (Number(this.dialog.data.beishuniu8) > 8) {
          this.$message.error("牛八倍数不可大于8");
          return;
        }
        if (Number(this.dialog.data.beishuniu9) > 9) {
          this.$message.error("牛九倍数不可大于9");
          return;
        }
        if (Number(this.dialog.data.beishuniu10) > 10) {
          this.$message.error("牛牛倍数不可大于10");
          return;
        }
        this.dialog.data.RewardRateEx.beishu.push(
          Number(this.dialog.data.beishuniu1)
        );
        this.dialog.data.RewardRateEx.beishu.push(
          Number(this.dialog.data.beishuniu2)
        );
        this.dialog.data.RewardRateEx.beishu.push(
          Number(this.dialog.data.beishuniu3)
        );
        this.dialog.data.RewardRateEx.beishu.push(
          Number(this.dialog.data.beishuniu4)
        );
        this.dialog.data.RewardRateEx.beishu.push(
          Number(this.dialog.data.beishuniu5)
        );
        this.dialog.data.RewardRateEx.beishu.push(
          Number(this.dialog.data.beishuniu6)
        );
        this.dialog.data.RewardRateEx.beishu.push(
          Number(this.dialog.data.beishuniu7)
        );
        this.dialog.data.RewardRateEx.beishu.push(
          Number(this.dialog.data.beishuniu8)
        );
        this.dialog.data.RewardRateEx.beishu.push(
          Number(this.dialog.data.beishuniu9)
        );
        this.dialog.data.RewardRateEx.beishu.push(
          Number(this.dialog.data.beishuniu10)
        );
        this.dialog.data.RewardRateEx.feerate.push(
          Number(this.dialog.data.feerateniu1)
        );
        this.dialog.data.RewardRateEx.feerate.push(
          Number(this.dialog.data.feerateniu2)
        );
        this.dialog.data.RewardRateEx.feerate.push(
          Number(this.dialog.data.feerateniu3)
        );
        this.dialog.data.RewardRateEx.feerate.push(
          Number(this.dialog.data.feerateniu4)
        );
        this.dialog.data.RewardRateEx.feerate.push(
          Number(this.dialog.data.feerateniu5)
        );
        this.dialog.data.RewardRateEx.feerate.push(
          Number(this.dialog.data.feerateniu6)
        );
        this.dialog.data.RewardRateEx.feerate.push(
          Number(this.dialog.data.feerateniu7)
        );
        this.dialog.data.RewardRateEx.feerate.push(
          Number(this.dialog.data.feerateniu8)
        );
        this.dialog.data.RewardRateEx.feerate.push(
          Number(this.dialog.data.feerateniu9)
        );
        this.dialog.data.RewardRateEx.feerate.push(
          Number(this.dialog.data.feerateniu10)
        );
        this.dialog.data.RewardRateEx.hefeerate = Number(
          this.dialog.data.hefeerate
        );
        this.dialog.data.RewardRateEx = JSON.stringify(
          this.dialog.data.RewardRateEx
        );
        this.dialog.data.FeeRate = `${this.dialog.data.feerateniu1}`;
      }
      app.getGoogleCode((GoogleCode) => {
        this.dialog.data.GoogleCode = GoogleCode;
        if (this.dialog.type == "alter") {
          this.dialog.data.TrxLimitMin = Number(this.dialog.data.TrxLimitMin);
          this.dialog.data.TrxLimitMax = Number(this.dialog.data.TrxLimitMax);
          this.dialog.data.UsdtLimitMin = Number(this.dialog.data.UsdtLimitMin);
          this.dialog.data.UsdtLimitMax = Number(this.dialog.data.UsdtLimitMax);
          this.dialog.data.TrxLimitMinHe = Number(
            this.dialog.data.TrxLimitMinHe
          );
          this.dialog.data.TrxLimitMaxHe = Number(
            this.dialog.data.TrxLimitMaxHe
          );
          this.dialog.data.UsdtLimitMinHe = Number(
            this.dialog.data.UsdtLimitMinHe
          );
          this.dialog.data.UsdtLimitMaxHe = Number(
            this.dialog.data.UsdtLimitMaxHe
          );
          this.dialog.data.SUsdtLimitMax = Number(
            this.dialog.data.SUsdtLimitMax
          );
          this.dialog.data.PUsdtLimitMax = Number(
            this.dialog.data.PUsdtLimitMax
          );
          this.dialog.data.BackFeeRate = Number(this.dialog.data.BackFeeRate);
          this.dialog.data.FenChengRate = Number(this.dialog.data.FenChengRate);
          this.dialog.data.FeeRate = Number(this.dialog.data.FeeRate);
          this.dialog.data.IsHot = this.tag == 2 ? 1 : 2;
          this.dialog.data.IsNew = this.tag == 3 ? 1 : 2;
          this.dialog.data.IsRecom = this.tag == 4 ? 1 : 2;
          app.post("/game/modify", this.dialog.data, () => {
            this.handleQuery(this.page);
            this.dialog.show = false;
            this.$message.success(this.$t('ModificationSuccessful'));
          });
        }
        if (this.dialog.type == "add") {
          this.dialog.data.UsdtLimitMin = Number(this.dialog.data.UsdtLimitMin);
          this.dialog.data.UsdtLimitMax = Number(this.dialog.data.UsdtLimitMax);
          this.dialog.data.TrxLimitMin = Number(this.dialog.data.TrxLimitMin);
          this.dialog.data.TrxLimitMax = Number(this.dialog.data.TrxLimitMax);
          this.dialog.data.TrxLimitMinHe = Number(
            this.dialog.data.TrxLimitMinHe
          );
          this.dialog.data.TrxLimitMaxHe = Number(
            this.dialog.data.TrxLimitMaxHe
          );
          this.dialog.data.UsdtLimitMinHe = Number(
            this.dialog.data.UsdtLimitMinHe
          );
          this.dialog.data.UsdtLimitMaxHe = Number(
            this.dialog.data.UsdtLimitMaxHe
          );
          this.dialog.data.SUsdtLimitMax = Number(
            this.dialog.data.SUsdtLimitMax
          );
          this.dialog.data.PUsdtLimitMax = Number(
            this.dialog.data.PUsdtLimitMax
          );
          this.dialog.data.BackFeeRate = Number(this.dialog.data.BackFeeRate);
          this.dialog.data.AgentRate = Number(this.dialog.data.AgentRate);
          this.dialog.data.RewardRate = Number(this.dialog.data.RewardRate);
          for (let i = 0; i < this.hgames.length; i++) {
            if (this.dialog.data.GameId == this.hgames[i].id) {
              this.dialog.data.GameName = this.hgames[i].name;
            }
          }
          for (let j = 0; j < this.hrooms.length; j++) {
            if (this.dialog.data.RoomLevel == this.hrooms[i].id) {
              this.dialog.data.RoomName = this.hrooms[i].name;
            }
          }
          app.post("/game/add", this.dialog.data, () => {
            this.handleQuery(this.page);
            this.dialog.show = false;
          });
        }
      });
    },
    GameTypeChange() {
      this.filters.GameId = null;
    },
  },
};
</script>
<style scoped>
.dropdown-content {
  max-height: 400px; /* Set the height limit for the dropdown content */
  overflow-y: auto; /* Enable vertical scrolling */
  padding: 10px; /* Add padding for better appearance */
}
.square-button {
  width: 40px; /* 设置宽度 */
  height: 40px; /* 设置高度，确保与宽度相等 */
  padding: 0; /* 去掉默认内边距 */
  line-height: 40px; /* 设置行高，使文字垂直居中 */
  text-align: center; /* 使文字水平居中 */
}
.el-message-box__message p {
  word-break: break-word;
}
</style>
